
const initState = {

    booleanTermsOfServiceModalIsOpen: false,

};

const footerReducer = (state=initState, action) => {


    switch (action.type) {

        case 'DISPLAY_FOOTER_TERMS_OF_SERVICE_MODAL':

            return {
                ...state,
                booleanTermsOfServiceModalIsOpen: action.booleanTermsOfServiceModalIsOpen,

            }
        

        default:

            return state;
           
    }
    


}


export default footerReducer